import { render, staticRenderFns } from "./LoginWxBindCallBack.vue?vue&type=template&id=3c36eef0&scoped=true"
import script from "./LoginWxBindCallBack.vue?vue&type=script&lang=js"
export * from "./LoginWxBindCallBack.vue?vue&type=script&lang=js"
import style0 from "./LoginWxBindCallBack.vue?vue&type=style&index=0&id=3c36eef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c36eef0",
  null
  
)

export default component.exports